import React from 'react';

import { makeObservable, observable, action, computed } from 'mobx';

import AlertViewModel from '../Alert/viewModel';

export default class ChapterSelectorModalViewModel extends AlertViewModel {
  scrollRef = React.createRef();

  constructor() {
    super();

    makeObservable(this);
  }
}
